export const routePath = {
  base: '/',
  admin: {
    base: '/admin',
    accounts: 'accounts',
    createAccount: 'account/create',
    addUsers: 'account/create/add-users',
    editAccount: 'account/:accountId',
    editUsers: 'account/:accountId/users',
    registrations: 'registrations',
    createCustomer: 'tag/:tagCode/customer/create',
    editCustomer: 'tag/:tagCode/customer/:customerId',
    addCustomer: 'tag/:tagCode/customer/add',
    userList: 'admins/list',
  },
  veterinarian: {
    base: '/veterinarian',
    register: 'register-tag',
    qrCodeStream: 'scan/qrcode',
    createRegistration: 'tag/:tagCode/registration/create',
    createCustomer: 'tag/:tagCode/customer/create',
    registrations: 'registrations',
    addCustomer: 'tag/:tagCode/customer/add',
    editCustomer: 'tag/:tagCode/customer/:customerId',
    editUsers: 'account/users',
  },
  public: {
    scan: '',
    findTag: ':tagCode',
    viewAccess: 'view/:tagCode',
    qrCodeStream: 'scan/qrcode',
    register: 'tag/:tagCode/customer/register',
    payment: 'tag/:tagCode/customer/payment',
    paymentConfirmation: 'tag/customer/confirmation',
    customer: 'customer/view',
    editCustomer: 'customer/edit',
    customerAccess: 'customer/access',
    terms: 'terms/view',
  },
  login: '/login',
  resetPassword: '/reset-password',
  confirmEmailChange: '/confirm-email-change',
}

export const routeName = {
  admin: {
    default: 'admin',
    accounts: 'admin-vet-accounts',
    createAccount: 'admin-create-vet-account',
    addUsers: 'admin-create-add-users',
    editAccount: 'admin-manage-vet-account',
    editUsers: 'admin-manage-account-users',
    registrations: 'admin-veterinarian-registrations',
    createCustomer: 'admin-create-customer',
    addCustomer: 'admin-add-customer',
    editCustomer: 'admin-manage-customer',
    userList: 'admin-role-user-list',
  },
  veterinarian: {
    default: 'veterinarian',
    register: 'veterinarian-register-tag',
    registrations: 'veterinarian-registrations',
    createRegistration: 'veterinarian-create-tag-registration',
    createCustomer: 'veterinarian-create-customer',
    addCustomer: 'veterinarian-add-customer',
    editCustomer: 'veterinarian-manage-customer',
    qrCodeStream: 'veterinarian-qr-code-stream',
    editUsers: 'manage-account-users',
  },
  public: {
    default: 'public',
    qrCodeStream: 'public-qr-code-stream',
    scan: 'public-scan',
    findTag: 'public-find-tag',
    viewAccess: 'public-view-access',
    register: 'public-register-customer',
    payment: 'public-payment-customer',
    paymentConfirmation: 'public-payment-confirmation',
    customer: 'public-customer',
    editCustomer: 'public-manage-customer',
    customerAccess: 'public-customer-access',
    terms: 'public-terms',
  },
  login: 'login',
  resetPassword: 'reset-password',
  confirmEmailChange: 'confirm-email-change',
}
